type Unsubscribe = (() => void) | null

const subscriptions = {
  chat: null as Unsubscribe,
  room: null as Unsubscribe,
  incoming: null as Unsubscribe,
  peerDelete: null as Unsubscribe,
  redaction: null as Unsubscribe,
  presence: null as Unsubscribe,
}

export type MatrixSubscriptionKey = keyof typeof subscriptions

export function setMatrixSubscription(
  key: MatrixSubscriptionKey,
  unsubscribe: () => void,
): void {
  subscriptions[key]?.()
  subscriptions[key] = unsubscribe
}

export function clearMatrixSubscription(key: MatrixSubscriptionKey): void {
  subscriptions[key]?.()
  subscriptions[key] = null
}

export function clearAllMatrixSubscriptions(): void {
  for (const key of Object.keys(subscriptions) as MatrixSubscriptionKey[]) {
    clearMatrixSubscription(key)
  }
}
